export default __webpack_public_path__ + "static/media/Private-5g_End-To-End.292d2943.mp4";